export default "__VITE_ASSET__c4fb4187__"